const getBaseUrl = () => {
    // return "http://localhost:3000/";
    // return "https://mrguruadmin.reptileantitheft.com/";
    return "https://admin.mrguru.in/";
};
export { getBaseUrl };